import Head from 'next/head'

import IntegrationsScreen from '~/ui/screens/toolkitsList/integrations'
import { withAuth } from '~/utils/hoc'

function DashboardPage() {
  return (
    <>
      <Head>
        <title>Integrations | Composio</title>
      </Head>
      <IntegrationsScreen />
    </>
  )
}

export default withAuth(DashboardPage)
